import Personal, { PERSON } from "../../InmateDetails/Personal";
import AdditionalPersonalInformation from "./AdditionalPersonalInformation";
import AliasesList from "./AliasesList";
import { BookingsSectionTitle } from "../styles";
import PlaceBirthForm from "./PlaceBirthForm";
import DistinguishingCharacteristics from "./DistinguishingCharacteristics";
import PersonalMiscNumbersInfo from "./PersonalMiscNumbersInfo";
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import dayjs from "dayjs";
import AddressesList from "./AddressesList";
import { StyledHeadingBar } from "@/common/styles";
import { isNonEmptyVariable } from "@/util/common_function";
import EmergencyForm from "./EmergencyForm";

const PersonalInformationDetails = forwardRef(
  ({
    allFormRef,
    isStaff = false,
    showMainHeading = false,
    isBoxLayout = false,
    detailLevel = PERSON.BOOKINGS,
    startingPoint = "", // => "low","medium",
  }) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );

    const [personalInfo, setPersonalInfo] = useState(null);
    const [placeBirthInfo, setPlaceBirthInfo] = useState(null);
    const [emergencyDetails, setEmergencyDetails] = useState(null);
    const [extraPersonalInfo, setExtraPersonalInfo] = useState({});

    useEffect(() => {
      const bio = bookings?.bio?.[0];

      setPersonalInfo({
        ...bio,
        dob: bio?.dob ? dayjs(bio?.dob) : null,
        lastModified: bio?.lastModified ? dayjs(bio?.lastModified) : null,
      });

      setEmergencyDetails({
        ...bio,
      });

      setPlaceBirthInfo({
        fbi: bio?.fbi,
        sid: bio?.sid,
        pobType: isNonEmptyVariable(bio?.pobType)
          ? parseInt(bio?.pobType)
          : null,
        pobNciCid: bio?.pobNciCid,
        countryOfCitizenshipId: bio?.countryOfCitizenshipId,
        primaryLanguage: bio?.primaryLanguage,
      });

      // Set initial extra personal info (if any) from bookings
      setExtraPersonalInfo(bookings?.bio?.[0]?.bioExtra?.[0] || null);
    }, [bookings]);

    // Update bio (the main personal information) in Redux
    const updateForm = (value) => {
      dispatch(
        setBookings({
          ...bookings,
          bio: [
            {
              ...bookings?.bio?.[0],
              ...value,
            },
          ],
        })
      );
    };

    return (
      <>
        <div
          style={{
            border: isBoxLayout ? "2px solid rgba(0, 0, 0, 0.15)" : "none",
            marginBottom: isBoxLayout ? "25px" : "0",
          }}
        >
          {showMainHeading && (
            <StyledHeadingBar style={{ justifyContent: "space-between" }}>
              <div className="main-title">Personal Information</div>
              {/* <FolderFlagGroup showIconOnly/> */}
            </StyledHeadingBar>
          )}

          <div
            style={{
              padding: isBoxLayout ? "16px" : "0",
              maxHeight: isBoxLayout ? "350px" : "auto",
              overflow: isBoxLayout ? "auto" : "inherit",
            }}
          >
            <Personal
              formData={personalInfo}
              person={detailLevel}
              personalFormRef={allFormRef?.personalFormRef}
              updateForm={updateForm}
              startingPoint={startingPoint}
            />
            {detailLevel !== "LOW" && (
              <>
                {/* Aliases */}
                {!isStaff && (
                  <>
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "15px" }}
                    >
                      <span>List of aliases</span>
                    </BookingsSectionTitle>
                    <AliasesList
                      personalFormAliasesRef={
                        allFormRef?.personalFormAliasesRef
                      }
                    />
                  </>
                )}

                {/* Addresses */}
                <BookingsSectionTitle
                  style={{ marginBottom: "10px", marginTop: "15px" }}
                >
                  <span>List of addresses</span>
                </BookingsSectionTitle>
                <AddressesList />

                {!isStaff ? (
                  <>
                    {/* Place of Birth */}
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "20px" }}
                    >
                      <span>Place of Birth</span>
                    </BookingsSectionTitle>
                    <PlaceBirthForm
                      formData={placeBirthInfo}
                      updateForm={updateForm}
                      startingPoint={startingPoint}
                      bookingsFieldsEnabled={bookingsFieldsEnabled}
                      personalFormPlaceOfBirthRef={
                        allFormRef?.personalFormPlaceOfBirthRef
                      }
                    />

                    {/* Distinguishing Characteristics */}
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "15px" }}
                    >
                      <span>Distinguishing Characteristics</span>
                    </BookingsSectionTitle>
                    <DistinguishingCharacteristics
                      personalFormDistinguishingRef={
                        allFormRef?.personalFormDistinguishingRef
                      }
                    />

                    {/* Misc Numbers */}
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "25px" }}
                    >
                      <span>Misc Numbers</span>
                    </BookingsSectionTitle>
                    <PersonalMiscNumbersInfo />

                    {/* Additional Personal Information */}
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "20px" }}
                    >
                      <span>Additional Personal Information</span>
                    </BookingsSectionTitle>
                    <AdditionalPersonalInformation />
                  </>
                ) : (
                  <>
                    {/* Place of Birth */}
                    <BookingsSectionTitle
                      style={{ marginBottom: "10px", marginTop: "20px" }}
                    >
                      <span>Emergency Details</span>
                    </BookingsSectionTitle>
                    <EmergencyForm
                      formData={emergencyDetails}
                      updateForm={updateForm}
                      bookingsFieldsEnabled={bookingsFieldsEnabled}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
);

export default PersonalInformationDetails;
